import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { Kazaplan360ViewPageComponent } from './kazaplan-360-view-page/kazaplan-360-view-page.component';
import { KazaplanComponent } from './kazaplan.component';
import { KazaplanResolver } from './kazaplan-resolver';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

export const kazaplanViewSlug = 'view';
export const planIdSlug = 'planId';
export const kazaplanMediaSlug = 'kazaplan_media';
export const mediaIdSlug = 'mediaId';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'new',
  },
  {
    path: `:${planIdSlug}/edit`,
    component: KazaplanComponent,
    data: {
      noFooter: true,
      noHeader: true,
      isFullHeader: true,
      metas: {
        titleKey: 'meta.kazaplan.title-edit',
        descriptionKey: 'meta.kazaplan.description',
        follow: 'noindex, nofollow',
      },
      gtmContext: 'post-plan',
      dataLayerOwnerCheck: 'kazaplan',
    },
    resolve: {
      kazaplan: KazaplanResolver,
    },
  },
  {
    path: 'new',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: KazaplanComponent,
        data: {
          noFooter: true,
          noHeader: true,
          isFullHeader: true,
          metas: {
            titleKey: 'meta.kazaplan.title',
            descriptionKey: 'meta.kazaplan.description',
            follow: 'index, follow',
            customCanonicalPath: ['3d-home-design-software'],
          },
          gtmContext: 'post-plan',
        },
      },
      {
        path: `:${planIdSlug}`,
        component: KazaplanComponent,
        data: {
          noFooter: true,
          noHeader: true,
          isFullHeader: true,
          metas: {
            titleKey: 'meta.kazaplan.title',
            descriptionKey: 'meta.kazaplan.description',
            follow: 'noindex, nofollow',
          },
          gtmContext: 'post-plan',
        },
        resolve: {
          kazaplan: KazaplanResolver,
        },
      },
    ],
  },
  {
    path: 'new',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: KazaplanComponent,
        data: {
          noFooter: true,
          noHeader: true,
          isFullHeader: true,
          metas: {
            titleKey: 'meta.kazaplan.title',
            descriptionKey: 'meta.kazaplan.description',
            follow: 'index, follow',
            customCanonicalPath: ['3d-home-design-software'],
          },
          gtmContext: 'post-plan',
        },
      },
      {
        path: `:${planIdSlug}`,
        component: KazaplanComponent,
        data: {
          noFooter: true,
          noHeader: true,
          isFullHeader: true,
          metas: {
            titleKey: 'meta.kazaplan.title',
            descriptionKey: 'meta.kazaplan.description',
            follow: 'noindex, nofollow',
          },
          gtmContext: 'post-plan',
        },
        resolve: {
          kazaplan: KazaplanResolver,
        },
      },
    ],
  },
  {
    path: '360view', component: Kazaplan360ViewPageComponent,
    data: {
      isFullHeader: true,
      metas: {
        titleKey: 'meta.kazaplan-360view.title',
        descriptionKey: 'meta.kazaplan-360view.description',
        follow: 'noindex, nofollow',
      },
      gtmContext: 'post-plan',
    },
  },
  {
    path: ':mode', component: KazaplanComponent,
    data: {
      noFooter: true,
      noHeader: true,
      isFullHeader: true,
      metas: {
        titleKey: 'meta.kazaplan.title',
        descriptionKey: 'meta.kazaplan.description',
        follow: 'noindex, nofollow',
      },
      gtmContext: 'post-plan',
    },
  },
  {
    path: `${kazaplanViewSlug}`,
    loadChildren: () => import('../../modules/kazaplan/kazaplan-fullscreen/kazaplan-fullscreen.module').then(m =>
      m.KazaplanFullscreenModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
    LocalizeRouterModule,
  ],
})
export class KazaplanRoutingModule {
}
